"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityState = void 0;
const core_1 = require("@angular/core");
const enums_1 = require("../../../@shared-types/opportunites/enums");
let OpportunityState = class OpportunityState {
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", typeof (_a = typeof enums_1.EOpportunityState !== "undefined" && enums_1.EOpportunityState) === "function" ? _a : Object)
], OpportunityState.prototype, "state", void 0);
OpportunityState = __decorate([
    (0, core_1.Component)({
        selector: 'opportunity-state',
        template: `
    <ng-container [ngSwitch]="state">
      <tag *ngSwitchCase="'O'" text="Offen" color="green"></tag>

      <tag *ngSwitchCase="'C'" text="Geschlossen" color="red"></tag>

      <tag *ngSwitchCase="'P'" text="Zurückgestellt" color="orange"></tag>
    </ng-container>
  `,
    })
], OpportunityState);
exports.OpportunityState = OpportunityState;
